import axios from "axios";
import { store } from "../store/store";
import { logout } from "../store/slices/auth";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 300000, 
});


axiosInstance.interceptors.request.use(
  (config) => {
    const currentToken = store.getState().auth.token;

    if (currentToken) {
      config.headers["authorization"] = `Bearer ${currentToken}`;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);


// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    try {
      if (response) {
          response = response;
      }
    } catch (e) {
      console.error("Decryption failed:", e);
    }
    return response;
  },
  (error) => {
    const statusCode = error?.response?.status;
    const apiMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message;

    if (error?.response?.status === 401) {
      store.dispatch(logout());
      toast.error("Session expired. Please login again.");
      return Promise.resolve(error.response);
    }

    if (statusCode >= 500) {
      toast.error(apiMessage || "Server error. Please try again.");
      return Promise.resolve(error.response);
    }

    if (statusCode >= 400) {
      toast.error(apiMessage || "Request failed. Please try again.");
      return Promise.resolve(error.response);
    }

    toast.error("Network error. Please check your connection.");
    return Promise.resolve({
      status: 0,
      data: { message: "NETWORK_ERROR" },
      error,
    });
  }
);


export default axiosInstance;
